import { TextField, styled } from '@mui/material';

export const SearchField = styled(TextField)(() => ({
    '& input': { paddingTop: '17px', paddingBottom: '17px' },
    '& .MuiInputAdornment-root': { marginTop: '0 !important' }
}));
